import { modules } from '@veritone/glc-redux';

import { userPermissionsSagas } from '@user-permissions';

import appSaga from '../modules/app/sagas';
import { saga as ingestionSaga } from '../modules/engines/ingestion/saga';
import { saga as opticalTrackingSaga } from '../modules/engines/optical-tracking/saga';
import { saga as transcriptionSaga } from '../modules/engines/transcription/saga';
import { saga as voiceMaskSaga } from '../modules/engines/voice-mask/saga';
import { saga as speakerSeparationSaga } from '../modules/engines/speaker-separation/saga';
import {
  watchCreateJobFacesData,
  watchCreateJobFacesSuccess,
  watchDeleteDetectionResults,
  // watchLoadFacesStatus,
  // watchReLoadFacesStatus,
} from '../modules/facesTabModule/saga';
import filePickerRootSaga from '@common-modules/filePicker/saga';
import keyboardSagas from '@redact-modules/keyboard/saga';
// import {
//   watchCreateJobLicensePlatesData,
//   watchLoadLicensePlatesStatus,
// } from '@redact-modules/licensePlatesTabModule/saga';
import { initMediaDetails } from '../modules/mediaDetails/saga';
import { initNotification } from '@common-modules/notification/saga';
// import metricsSagas from '@redact-modules/metrics';
import overviewSaga from '@redact-modules/overview/saga';
import routeSaga from '@common-modules/routing/sagas';
import { uploadsSaga } from '@redact-modules/uploads/sagas';
import trimSaga from '@common-modules/trim/saga';
import { initRedactFile } from '@common-modules/redactFile/saga';
import { videoReactSaga } from '@common-modules/player/saga';
import {
  documentBurnInSaga,
  documentsSaga,
} from '@redact-modules/documents/sagas';
import { statusHistorySaga } from '@common-modules/statusHistory';
import { watchCheckRootOrganization } from '@redact-modules/admin/sagas';
const {
  auth: { authRootSaga },
} = modules;

// these are sagas that should run on *all* routes, at app startup.
// define route-specific sagas on the routesMap
export const sagas = [
  userPermissionsSagas,
  routeSaga,
  appSaga,
  authRootSaga,
  watchCreateJobFacesData,
  watchCreateJobFacesSuccess,
  watchDeleteDetectionResults,
  // watchLoadFacesStatus,
  // watchReLoadFacesStatus,
  // watchCreateJobLicensePlatesData,
  // watchLoadLicensePlatesStatus,
  overviewSaga,
  filePickerRootSaga,
  uploadsSaga,
  ingestionSaga,
  opticalTrackingSaga,
  transcriptionSaga,
  voiceMaskSaga,
  speakerSeparationSaga,
  initMediaDetails,
  keyboardSagas,
  // metricsSagas,
  trimSaga,
  initRedactFile,
  initNotification,
  videoReactSaga,
  documentsSaga,
  statusHistorySaga,
  // App-wide rather than on the admin routes, because the SIDE NAV asks the
  // question now: the Admin entry only appears for the instance root org, and
  // the drawer is reachable from every page. It was a route saga, which meant
  // the one page that dispatched the check without having one got no answer
  // and rendered as though the check were still running.
  watchCheckRootOrganization,
  // Its own keepAlive entry on purpose: a detached document burn-in must not
  // be cancelled by a throw in one of documentsSaga's siblings (VE-28061).
  documentBurnInSaga,
];
